import { formatTextbookTitle } from '../../utils/formatFields';
import normalize from '../../utils/normalizeString';
import { Select } from 'antd';
import { useEffect, useMemo } from 'react';
import textbooksAtom from '../../data/atoms/textbooks-defered.js';
import coursesAtom from '../../data/atoms/courses-defered.js';
import { useAtom } from 'jotai';

function ResourceSelect({ value, onChange, ...restProps }) {
  const [textbooks, dispatchTextbooksAction] = useAtom(textbooksAtom);
  const [courses, dispatchCoursesAction] = useAtom(coursesAtom);

  const courseOptions = useMemo(() => {
    let _coursesOptions = [];
    if (courses && Array.isArray(courses.data)) {
      _coursesOptions = courses.data.map(item => {
        return {
          key: `course-${item.id}`,
          value: item.id,
          label: item.name,
          data: {
            normalizedLabel: normalize(item.name),
            url: `${process.env.REACT_APP_URL}/course-packs/${item.slug}`,
            type: "course",
          }
        };
      });
    }
    return {
      label: "Course Packs",
      data: { normalizedLabel: "Course Packs" },
      options: _coursesOptions,
    };
  }, [courses]);

  const textbookOptions = useMemo(() => {
    let _textbooksOptions = [];
    if (textbooks && Array.isArray(textbooks.data)) {
      _textbooksOptions = textbooks.data.map(item => {
        const label = formatTextbookTitle(item);
        return {
          key: `textbook-${item.id}`,
          value: item.id,
          label: label,
          data: {
            normalizedLabel: normalize(label),
            url: `${process.env.REACT_APP_URL}/textbooks/${item.slug}`,
            type: "textbook",
          }
        };
      })

    }

    return {
      label: "Textbooks",
      data: { normalizedLabel: "Textbooks" },
      options: _textbooksOptions,
    };
  }, [textbooks]);

  // lazy load - AtomFactory {initialize: false, rereadOnMount: false}
  useEffect(
    () => {
      if (!textbooks.data) {
        dispatchTextbooksAction({
          type: "getAll",
        });
      }

      if (!courses.data) {
        dispatchCoursesAction({
          type: "getAll",
        });
      }
    },
    // eslint-disable-next-line
    []
  );

  const handleFilter = (searchValue, option) => {
    return option.data.normalizedLabel.indexOf(normalize(searchValue)) >= 0;
  };

  const handleChange = (value, option) => {
    if (typeof onChange === "function") {
      onChange({ ...value, url: option.data.url, type: option.data.type })
    }
  };

  return (
    <Select {...restProps}
      data-testid="select-resource"
      showArrow={true}
      style={{ width: '100%' }}
      optionFilterProp="label"
      options={[courseOptions, textbookOptions]}
      labelInValue={true}
      showSearch={true}
      filterOption={handleFilter}
      value={value}
      onChange={handleChange}
      getPopupContainer={triggerNode => triggerNode.parentElement} // fix for scrolling with the page

    />
  );
}

export default ResourceSelect;
